import lodash from 'lodash'
import React, { ReactElement, useEffect, useMemo, useState } from 'react'
import { useRecoilState } from 'recoil'

import {
  useField,
  useFieldContext,
} from '../../../../../1stlog-ui/src/components/Field'
import { usePrevious } from '../../../../../1stlog-ui/src/hooks'
import useOrderEntry from '../../useOrderEntry'
import { lastAddressStateFamily } from './state'

type TReadonlyAddressCacheProps = {
  //
}

const ReadonlyAddressCache = (
  props: TReadonlyAddressCacheProps,
): ReactElement => {
  // const {} = props

  const { id } = useOrderEntry()

  const { prefix } = useFieldContext()

  const stateId = `${id}_${prefix}`

  const isEdit = useField('isEdit')

  const [address, setAddress] = useField('address', { asState: true })

  const [lastAddress, setLastAddress] = useRecoilState(
    lastAddressStateFamily(stateId),
  )
  const previousIsEdit = usePrevious(isEdit)
  useEffect(() => {
    // console.log('isEdit has changed', {
    //   prefix,
    //   previousIsEdit,
    //   isEdit,
    //   address,
    //   lastAddress,
    // })
    // save current address, and switching to editing
    if (previousIsEdit === false && isEdit === true) {
      // console.log('save current address, and switching to editing', {
      //   address,
      //   previousIsEdit,
      //   isEdit,
      // })
      setLastAddress(address)
      setTimeout(() => setAddress({ country: address.country }), 0)
    }
    // restore cached address, since switching from editing to readonly
    if (previousIsEdit && !isEdit) {
      // console.log(
      //   'restore cached address, since switching from editing to readonly',
      //   { lastAddress },
      // )
      setTimeout(() => setAddress(lastAddress), 0)
    }
  }, [isEdit])

  return <>{/* <pre>{JSON.stringify({ prefix, isEdit }, null, 2)}</pre> */}</>
}

export default ReadonlyAddressCache
